import {
  Component,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NotificationService } from "core-client/api";
import { AppVersionsUpdateService } from "./services/app-versions-update.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title: string = "ADDboard";

  constructor(
    private readonly appVersionsUpdate: AppVersionsUpdateService,
    private readonly titleService: Title,
    private readonly notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.appVersionsUpdate.startMonitoring();
    this.notificationService.bootstrapPermissionRequest();
  }

  ngOnDestroy(): void {
    this.appVersionsUpdate.stopMonitoring();
  }
}
